import { networkMiddleware, networkReducer } from "@nerdjs/nerd-network";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { rhapsodyApi } from "./api";
import { mainMiddleware } from "./mainMiddleware";
import { rhapsodyReducerSlice } from "./rhapsodyReducer";

const rootReducer = combineReducers({
  [rhapsodyApi.reducerPath]: rhapsodyApi.reducer,
  [rhapsodyReducerSlice.name]: rhapsodyReducerSlice.reducer,

  networkState: networkReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
  reducer: rootReducer,
  middleware: [
    thunkMiddleware,
    rhapsodyApi.middleware,
    mainMiddleware,
    networkMiddleware, // Always add networkMiddleware after your api middleware
  ],
});

export type AppDispatch = typeof store.dispatch;
